
export default {
  scoreHistogramContext: null,
  statusScoreHistogram: '',
  areaHistogramContext: null,
  statusAreaHistogram: '',
  statusHarvestResult: '',
  harvestResultContext: null,
};
